<ds-modal
  id="choosePaymentMethod"
  class="paymentModal"
  [closeOthers]="true"
  [maxWidth]="450"
  [fullScreen]="true"
  [defaultCloseButton]="true"
>
  <ds-add-payment-method-quicklinks
    [authorizedToAddPaymentMethod]="true"
    (addCheckingAccountEvent)="addCheckingAccount()"
    (addCreditDebitEvent)="addCreditDebit()"
    [newBillingDesign]="true"
    [isHSPolicy]="true"
  >
  </ds-add-payment-method-quicklinks>
</ds-modal>
